export default __webpack_public_path__ + "static/media/salatka.1ac1ca45.svg";